import { useUserService } from '@/entities/user/api';
import { useAuthService } from '@/features/AuthForm/api';
import { useTokenService } from '@/entities/token/api';
import { useFavoriteService } from '@/entities/favorite/api';
import { useLawyerService } from '@/entities/lawyer/api';
import { useLocationService } from '@/entities/location/api';
import { useCategoriesService } from '@/entities/category/api';
import { useGeoService } from '@/entities/geo/api';
import { useSearchService } from '@/entities/search/api';
import { useMorphService } from '@/entities/morph/api';
import { useCallbackService } from '@/entities/callback/api';
import { useComplaintService } from '@/entities/complaint/api';
import { useFeedbackService } from '@/entities/feedback/api';
import { useAppointmentService } from '@/entities/appointment/api';
import { usePracticeService } from '@/entities/practice/api';
import { usePublicationService } from '@/entities/publication/api';
import { useJournalService } from '@/entities/journal/api';
import { useChatService } from '@/entities/chat/api';
import { useAssistantService } from '@/entities/assistant/api';

export default defineNuxtPlugin({
  name: 'services',
  setup() {
    return {
      provide: {
        userService: useUserService(),
        authService: useAuthService(),
        tokenService: useTokenService(),
        favoriteService: useFavoriteService(),
        lawyerService: useLawyerService(),
        locationService: useLocationService(),
        categoriesService: useCategoriesService(),
        geoService: useGeoService(),
        searchService: useSearchService(),
        morphService: useMorphService(),
        callbackService: useCallbackService(),
        complaintService: useComplaintService(),
        feedbackService: useFeedbackService(),
        appointmentService: useAppointmentService(),
        practiceService: usePracticeService(),
        publicationService: usePublicationService(),
        journalService: useJournalService(),
        chatService: useChatService(),
        assistantService: useAssistantService(),
      },
    };
  },
});
